// @flow
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import starYellow from '../../../../../assets/img/starYellow.png';
import starGrey from '../../../../../assets/img/starGrey.png';

type Props = {|
  size?: number,
  punctuation: number,
  className?: string,
|};

const useStyles = ({size, percentagePunt}) =>
  makeStyles(theme => ({
    starRatingWrap: {
      height: size ? `${size / 5}px` : '20px',
      position: 'relative',
      width: size ? `${size}px` : '20px',
      '&:before': {
        backgroundImage: `url(${starGrey})`,
        backgroundRepeat: 'repeat-x',
        backgroundSize: size ? `${size / 5}px` : '20px',
        bottom: 0,
        content: "''",
        display: 'block',
        height: size ? `${size / 5}px` : '20px',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        width: size ? `${size}px` : '20px',
      },
    },
    star: {
      width: percentagePunt ? `${percentagePunt}%` : '20px',
      display: 'block',
      textIndent: '-10000px',
      height: size ? `${size / 5}px` : '20px',
      position: 'absolute',
      overflow: 'hidden',
      '&:before': {
        backgroundImage: `url(${starYellow})`,
        backgroundRepeat: 'repeat-x',
        backgroundSize: size ? `${size / 5}px` : '20px',
        bottom: 0,
        content: "''",
        display: 'block',
        height: size ? `${size / 5}px` : '20px',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        width: size ? `${size}px` : '20px',
      },
    },
  }));

export default function StarRating(props: Props) {
  const {size = 116, punctuation, className} = props;
  const percentagePunt = (punctuation * 100) / 5;

  const styleProps = {size, percentagePunt};
  const classes = useStyles(styleProps)();

  return (
    <div className={`${className ? className : ''} ${classes.starRatingWrap}`}>
      <span className={classes.star} />
    </div>
  );
}
StarRating.propTypes = {
  size: PropTypes.number,
  punctuation: PropTypes.number.isRequired,
  className: PropTypes.string,
};
